import { render, staticRenderFns } from "./pay-plan.vue?vue&type=template&id=04e1f590"
import script from "./pay-plan.vue?vue&type=script&lang=js"
export * from "./pay-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports